import React, { useState } from 'react';
import { ONBOARDING_STEPS } from '../../../../../utils/constants';
import './BubbleNavigator.scss';
import { FormValues } from '../../../../../types';
import blueDownArrow from '../../../../../assets/images/blue-down-arrow.png';
import blueCalculatorIcon from '../../../../../assets/images/blue-calculator-icon.png';

interface DummyBubbleNavigatorProps {
  quantity?: number;
}

export const DummyBubbleNavigator: React.FC<DummyBubbleNavigatorProps> = (props) => {
  const { quantity = 5 } = props;

  const [selectedIndex, setSelectedIndex] = useState<number>(0)

  return <BubbleNavigator {...{ selectedIndex, setSelectedIndex, quantity, values: {} as FormValues}}/>
}

interface BubbleNavigatorProps {
  selectedIndex: number;
  setSelectedIndex: (index: number, options?: { force?: boolean }) => void;
  quantity: number;
  values: FormValues;
  maxAllowedStepIndex?: number;
}

export const BubbleNavigator: React.FC<BubbleNavigatorProps> = (props) => {
  const { selectedIndex, setSelectedIndex, quantity, values, maxAllowedStepIndex } = props;

  return (
    <div className='bubble-container'>
      {
        Array
          .from(Array(quantity).keys())
          .map(
            (i) => {
              // Block future steps: can only go to maxAllowedStepIndex + 1 (next step after last completed)
              const isFutureStep = maxAllowedStepIndex !== undefined && i > maxAllowedStepIndex + 1;
              const isDisabled = isFutureStep || Object.keys(values).length < i;
              
              return (
                <Bubble
                  key={`${i}_{selectedIndex}`}
                  isSelected={i === selectedIndex}
                  onClick={() => {
                    if (!isDisabled) {
                      setSelectedIndex(i);
                    }
                  }} 
                  isDisabled={isDisabled}
                />
              );
            }
          ) 
      }
      <div className='arrow'>
        <img src={blueDownArrow} alt='arrow'/>
      </div>
      <div className='calc'>
        <img src={blueCalculatorIcon} alt='calc'/>
      </div>
    </div>
  );
}

interface BubbleProps {
  isSelected: boolean;
  onClick: () => void;
  isDisabled: boolean;
}

const Bubble: React.FC<BubbleProps> = (props) => {
  const { isSelected, onClick, isDisabled } = props;

  let className = 'bubble';
  if (isSelected) {
    className += ' selected';
  }
  if (isDisabled) {
    className += ' disabled';
  }

  return (
    <div {...{ className, onClick }}></div>
  )
}

interface BubbleNavigatorContainerProps {
  children: React.ReactNode;
}

export const BubbleNavigatorContainer: React.FC<BubbleNavigatorContainerProps> = ({ children }) => (
  <div className='bubble-navigator-container'>
    {children}
  </div>
) 